import { trackEventFirebaseService } from 'analytics';
import Sentry from 'util/sentry';

const sendWsp = (event, params = {}) => {
    try {
        const { number, msg } = params

        if (msg) {
            window.open(`https://wa.me/${number}?text=${encodeURIComponent(msg)}`)
        } else {
            window.open(`https://wa.me/${number}`)
        }

        trackEventFirebaseService(event, params)
    } catch (err) {
        Sentry.captureException(err, { 
            message: 'Error en el evento "sendWsp()"',
            extra: { params }
        })
    }
}

export default sendWsp
